import * as tslib_1 from "tslib";
import { AmbientBasicChunk } from "./AmbientBasicChunk";
/**
 * AmbientDepthChunk provides a debug method to visualise depth maps
 */
var AmbientDepthChunk = (function (_super) {
    tslib_1.__extends(AmbientDepthChunk, _super);
    /**
     * Creates a new AmbientBasicChunk object.
     */
    function AmbientDepthChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._shadowTexture = shader.getAbstraction(method.castingLight.shadowMapper.depthMap);
        return _this;
    }
    /**
     * @inheritDoc
     */
    AmbientDepthChunk.prototype._initConstants = function () {
        var data = this._shader.fragmentConstantData;
        var index = this._decRegIndex;
        data[index] = 1.0;
        data[index + 1] = 1 / 255.0;
        data[index + 2] = 1 / 65025.0;
        data[index + 3] = 1 / 16581375.0;
    };
    AmbientDepthChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        var decReg;
        var decReg = registerCache.getFreeFragmentConstant();
        this._decRegIndex = decReg.index * 4;
        code += this._shadowTexture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying) +
            "dp4 " + targetReg + ".x, " + targetReg + ", " + decReg + "\n" +
            "mov " + targetReg + ".yz, " + targetReg + ".xx			\n" +
            "mov " + targetReg + ".w, " + decReg + ".x\n" +
            "sub " + targetReg + ".xyz, " + decReg + ".xxx, " + targetReg + ".xyz\n";
        return code;
    };
    return AmbientDepthChunk;
}(AmbientBasicChunk));
export { AmbientDepthChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/AmbientDepthChunk.js